export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      label: 'Address',
      value: 'Av. Panamericana y Jose Maria Torrijos',
      link: null
    },
    {
      icon: 'ri-building-line',
      label: 'City',
      value: 'Panama',
      link: null
    },
    {
      icon: 'ri-mail-line',
      label: 'Zip',
      value: '07215',
      link: null
    },
    {
      icon: 'ri-global-line',
      label: 'Country',
      value: 'Panama',
      link: null
    },
    {
      icon: 'ri-mail-send-line',
      label: 'Email',
      value: 'support@articruzsa.com',
      link: 'mailto:support@articruzsa.com'
    },
    {
      icon: 'ri-phone-line',
      label: 'Number',
      value: '+1 9802916390',
      link: 'tel:+19802916390'
    }
  ];

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Have questions about our products? We're here to help and would love to hear from you
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${info.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                    {info.label}
                  </h3>
                  {info.link ? (
                    <a
                      href={info.link}
                      className="text-base font-medium text-gray-900 hover:text-teal-500 transition-colors break-words cursor-pointer"
                    >
                      {info.value}
                    </a>
                  ) : (
                    <p className="text-base font-medium text-gray-900 break-words">
                      {info.value}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-white rounded-2xl shadow-lg p-8">
            <div className="flex items-center gap-4 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/3d31840e-c611-420e-93b1-70e5b4525099.png" 
                alt="Articruz S A Logo" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-2xl font-bold text-gray-900">Articruz S A</h3>
            </div>
            <p className="text-gray-600 max-w-md">
              Developing innovative iOS applications that prioritize security, performance, and user experience
            </p>
          </div>
        </div>
      </div>

      <footer className="mt-20 pt-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © 2025 Articruz S A. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              className="text-sm text-gray-500 hover:text-teal-500 transition-colors whitespace-nowrap cursor-pointer"
              rel="nofollow"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </section>
  );
}
